import React from "react";
import { BRAND } from "../mock/mock";
import { Instagram, MapPin, Phone, ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="pt-20 pb-8 bg-viimii-2 border-t hairline relative">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-4 gap-10 pb-14">
          <div className="md:col-span-2">
            <img src="/brand/viimii-word-dark.png" alt="VIIMII STUDIO" className="h-10 w-auto" />
            <p className="section-line text-gold-soft mt-3">Nails · Lashes · Hair Spa</p>
            <p className="mt-5 text-cream/60 max-w-sm leading-relaxed">
              Mumbai's boho-luxe nail & hair spa destination - where every visit becomes
              a beautiful, personalised ritual.
            </p>
            <a
              href={BRAND.instagram}
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full border hairline text-cream/85 hover:text-gold transition-colors"
            >
              <Instagram size={16} /> {BRAND.instagramHandle}
            </a>
          </div>

          <div>
            <h4 className="section-line text-cream/50 mb-5">Explore</h4>
            <ul className="space-y-3 text-cream/70">
              {[["About", "/about"], ["Services", "/services"], ["Portfolio", "/portfolio"], ["Pricing", "/pricing"], ["Contact", "/contact"]].map(([l, h]) => (
                <li key={l}><Link to={h} className="hover:text-gold transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="section-line text-cream/50 mb-5">Visit Us</h4>
            <ul className="space-y-4 text-cream/70 text-sm">
              <li className="flex gap-2"><MapPin size={16} className="shrink-0 mt-0.5 text-gold" style={{ color: "var(--viimii-gold)" }} /> {BRAND.address}</li>
              <li className="flex gap-2"><Phone size={16} className="shrink-0 text-gold" style={{ color: "var(--viimii-gold)" }} /> {BRAND.phone}</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t hairline">
          <p className="text-xs text-cream/40">© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/admin" className="text-xs text-cream/40 hover:text-gold transition-colors">Studio Admin</Link>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="w-10 h-10 rounded-full grid place-items-center border hairline text-gold hover:bg-gold hover:text-black transition-all"
              aria-label="Back to top"
            >
              <ArrowUp size={16} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
